'use client'

import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { Globe, Percent, Shield, Zap } from 'lucide-react'

const stats = [
  {
    icon: Globe,
    value: '150M+',
    label: 'Merchants',
    description: 'Anywhere Visa is accepted',
  },
  {
    icon: Zap,
    value: 'Real-Time',
    label: 'Credit',
    description: 'Borrows at the moment of purchase',
  },
  {
    icon: Percent,
    value: '$0',
    label: 'Annual Fee',
    description: 'No annual card fee',
  },
  {
    icon: Shield,
    value: 'On-Chain',
    label: 'Always',
    description: 'Assets stay on-chain',
  },
]

export function CardStats() {
  return (
    <section className="py-12 lg:py-16">
      <div className="mx-auto max-w-6xl px-4 lg:px-8 sm:px-6">
        <Panel.Wrapper className="overflow-hidden bg-gradient-to-br from-gradient-yellow/10 via-background to-gradient-green/10">
          <Panel.Content className="p-6 md:p-8">
            <div className="grid gap-8 lg:grid-cols-4 sm:grid-cols-2">
              {stats.map((stat) => (
                <div key={stat.label} className="flex flex-col items-center text-center">
                  <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-gradient-yellow/20 to-gradient-green/20">
                    <stat.icon className="h-5 w-5 text-dim-foreground" />
                  </div>
                  <Typography variant="h2" className="text-2xl lg:text-3xl" gradient style={{ alignSelf: 'center' }}>
                    {stat.value}
                  </Typography>
                  <Typography variant="h4" className="mt-1">
                    {stat.label}
                  </Typography>
                  <Typography variant="p" className="mt-1 text-muted-foreground text-sm">
                    {stat.description}
                  </Typography>
                </div>
              ))}
            </div>
          </Panel.Content>
        </Panel.Wrapper>
      </div>
    </section>
  )
}
